import { render, staticRenderFns } from "./IconRatingReview.vue?vue&type=template&id=6775a407"
import script from "./IconRatingReview.vue?vue&type=script&lang=js"
export * from "./IconRatingReview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports